import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'load',
    standalone: false
})
export class LoadPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value >= 100) {
      return '#FFFF00';
    } else if (value >= 80) {
      return '#ffe066';
    } else if (value >= 60) {
      return '#f4b800';
    } else if (value >= 40) {
      return '#ff8000';
    } else if (value >= 20) {
      return '#ff1100fd';
    } else if (value >= 0) {
      return '#cc0000';
    } else {
      return '#808080';
    }
  }

}
